module.exports = __webpack_public_path__ + "static/media/refresh.fb3d4d89.svg";